import Magazine from "./Magazine";

export default Magazine;
